export default {
  block_td: {
    fontSize: '0px',
    padding: '0px 40px',
  },
  block_td_fullwidth: {
    fontSize: '0px',
    padding: '0px',
  },
}
